/** @format */

'use strict';
// Generated by jhipster/controller/genericOverviewWithPaging.ftl

angular
	.module('emsApp')
	.controller('DocumentController', function(
		$scope,
		$rootScope,
		$state,
		$stateParams,
		$q,
		AlertService,
		DocumentFactory,
		FindAllDocumentsByQueryParamsFactory,
		AutocompleteCarsByQueryParamsFactory,
		AutocompleteRelationsByQueryParamsFactory,
		AutocompleteEventsByQueryParamsFactory,
		NoPagingDocumentFactory,
		NoPagingDocumentTypeFactory,
		NoPagingCarFactory,
		NoPagingLocationFactory,
		NoPagingRelationFactory,
		NoPagingEventFactory,
		DocumentDownloadService
	) {
		$scope.documentList = [];
		$scope.showSearchForm = true;
		// a custom hook could be implemented here to add additional fields: custom/jhipster/controller/overview/additional-fields.ftl

		if ($rootScope.isDefinedAndNotNull($rootScope.pageSizeDocument)) {
			$scope.pageSize = angular.copy($rootScope.pageSizeDocument);
		} else {
			$scope.pageSize = 20;
			// A custom hook for setting page size can be implemented here: custom/jhipster/controller/overview/overview_uses_paging.ftl
			$rootScope.pageSizeDocument = angular.copy($scope.pageSize);
		}

		$scope.goToNewState = function() {
			// this overview is NOT mapped, it is the main overview
			$state.go('document.list.new');
		};

		$scope.goToEditState = function(document) {
			// this overview is NOT mapped, it is the main overview
			$state.go('document.list.edit', { documentId: document.id });
		};

		var getTypeId = function() {
			if ($rootScope.isDefinedAndNotNull($scope.DocumentSearchOverview.type)) {
				return $scope.DocumentSearchOverview.type.id;
			} else {
				return undefined;
			}
		};

		var getCarId = function() {
			if ($rootScope.isDefinedAndNotNull($scope.DocumentSearchOverview.car)) {
				return $scope.DocumentSearchOverview.car.id;
			} else {
				return undefined;
			}
		};

		var getLocationId = function() {
			if ($rootScope.isDefinedAndNotNull($scope.DocumentSearchOverview.location)) {
				return $scope.DocumentSearchOverview.location.id;
			} else {
				return undefined;
			}
		};

		var getRelationId = function() {
			if ($rootScope.isDefinedAndNotNull($scope.DocumentSearchOverview.relation)) {
				return $scope.DocumentSearchOverview.relation.id;
			} else {
				return undefined;
			}
		};

		var getEventId = function() {
			if ($rootScope.isDefinedAndNotNull($scope.DocumentSearchOverview.event)) {
				return $scope.DocumentSearchOverview.event.id;
			} else {
				return undefined;
			}
		};

		// handle attribute createdOn of javaType java.time.ZonedDateTime
		$scope.processCreatedOn = function() {
			var createdOnFromDefined = $rootScope.isDefinedAndNotNull($scope.DocumentSearchOverview.createdOnFrom);
			var createdOnToDefined = $rootScope.isDefinedAndNotNull($scope.DocumentSearchOverview.createdOnTo);

			// TODO either we assign a value, or undefined, plus we check for undefined, hence we could assign the variable, period

			if (createdOnFromDefined) {
				$scope.DocumentSearchOverview.createdOnFromString = $rootScope.convertDateWithoutZone($scope.DocumentSearchOverview.createdOnFrom);
			} else {
				$scope.DocumentSearchOverview.createdOnFromString = undefined;
			}

			if (createdOnToDefined) {
				$scope.DocumentSearchOverview.createdOnToString = $rootScope.convertDateWithoutZone($scope.DocumentSearchOverview.createdOnTo);
			} else {
				$scope.DocumentSearchOverview.createdOnToString = undefined;
			}
		};

		/**
		 * This function queries all entities of type Type and checks if this Document dialog is called in the context of Type.
		 * If this is the case, we detect the parent entity Document and select it as model value so it is shown in the dropdown select.
		 */
		$scope.queryType = function() {
			return NoPagingDocumentTypeFactory.query(function(result) {
				return result;
			});
		};
		$scope.typeReferenceFilterList = $scope.queryType();

		$scope.autocompleteCars = function(val) {
			var params = {
				carTypeAheadSearchString: val,
			};

			return AutocompleteCarsByQueryParamsFactory.query(params).$promise.then(function(results) {
				return results;
			});
		};

		/**
		 * This function queries all entities of type Location and checks if this Document dialog is called in the context of Location.
		 * If this is the case, we detect the parent entity Document and select it as model value so it is shown in the dropdown select.
		 */
		$scope.queryLocation = function() {
			return NoPagingLocationFactory.query(function(result) {
				return result;
			});
		};
		$scope.locationReferenceFilterList = $scope.queryLocation();

		$scope.autocompleteRelations = function(val) {
			var params = {
				relationTypeAheadSearchString: val,
			};

			return AutocompleteRelationsByQueryParamsFactory.query(params).$promise.then(function(results) {
				return results;
			});
		};

		$scope.autocompleteEvents = function(val) {
			var params = {
				eventTypeAheadSearchString: val,
			};

			return AutocompleteEventsByQueryParamsFactory.query(params).$promise.then(function(results) {
				return results;
			});
		};

		$scope.search = function() {
			$('#search-button').addClass('glyphicon-refresh-animate');

			// Call the javascript functions to handle search parameters
			$scope.processCreatedOn();

			$rootScope.DocumentSearchOverview = angular.copy($scope.DocumentSearchOverview);

			// A custom hook for setting page size can be implemented here: custom/jhipster/controller/overview/overview_uses_paging.ftl
			$rootScope.pageSizeDocument = angular.copy($scope.pageSize);

			FindAllDocumentsByQueryParamsFactory.query(
				{
					page: $scope.DocumentSearchOverview.page - 1,
					size: $scope.pageSize,
					createdOnFrom: $scope.DocumentSearchOverview.createdOnFromString,
					createdOnTo: $scope.DocumentSearchOverview.createdOnToString,
					name: $scope.DocumentSearchOverview.name,
					typeId: getTypeId(),
					carId: getCarId(),
					locationId: getLocationId(),
					relationId: getRelationId(),
					eventId: getEventId(),

					sort: [$scope.DocumentSearchOverview.predicate + ',' + ($scope.DocumentSearchOverview.ascending ? 'asc' : 'desc')],
				},
				function(result, headers) {
					$scope.totalItems = headers('X-Total-Count');
					$scope.totalCountIsKnownAtTheMoment = true;
					$scope.documentList = result;
					$('#search-button').removeClass('glyphicon-refresh-animate');
				}
			);
		};

		$scope.isDocumentSearchOverviewDirty = function() {
			return !angular.equals($scope.DocumentSearchOverview, $scope.originalDocumentSearchOverview);
		};

		$scope.loadDefaultSearchParams = function() {
			$rootScope.DocumentSearchOverview = {};
			$rootScope.DocumentSearchOverview.page = 1;
			$rootScope.DocumentSearchOverview.predicate = 'id';
			$rootScope.DocumentSearchOverview.ascending = false;

			$scope.DocumentSearchOverview = angular.copy($rootScope.DocumentSearchOverview);

			$scope.originalDocumentSearchOverview = angular.copy($scope.DocumentSearchOverview);
		};

		$scope.reset = function() {
			$scope.loadDefaultSearchParams();
			if ($rootScope.isDefinedAndNotNull($scope.searchForm)) {
				// we check the availability of search form as it is still used in search forms that are not inlined in the table
				$scope.searchForm.$setPristine();
			}
			$scope.search();
		};

		$scope.loadPage = function() {
			if (angular.isUndefined($rootScope.DocumentSearchOverview) || $rootScope.DocumentSearchOverview === null) {
				$scope.loadDefaultSearchParams(); // load defaults
			}

			$scope.DocumentSearchOverview = angular.copy($rootScope.DocumentSearchOverview);
			$scope.search();
		};

		$scope.singleDelete = function(id) {
			$scope.selectedDocumentId = id;
			$('#deleteDocumentConfirmation').modal('show');
		};

		$scope.confirmSingleDelete = function() {
			DocumentFactory.delete(
				{ id: $scope.selectedDocumentId },
				function() {
					$scope.search();
					$('#deleteDocumentConfirmation').modal('hide');
				},
				function(error) {
					$('#deleteDocumentConfirmation').modal('hide');
					AlertService.error(error.data.message, error.data.params);
				}
			);
		};

		$scope.downloadDocument = function(id) {
			DocumentDownloadService(id);
		};

		$scope.loadPage();

		$scope.getSortIcon = function(itemName) {
			if ($scope.DocumentSearchOverview.predicate === itemName) {
				if ($scope.DocumentSearchOverview.ascending) {
					return 'glyphicon-sort-by-attributes';
				} else {
					return 'glyphicon-sort-by-attributes-alt';
				}
			} else {
				return 'glyphicon-sort';
			}
		};
	});
